/**
 * TMF9 Apex - Rotas do Cliente
 *
 * Registra todas as rotas /apex/* no React Router do TMF9 base.
 * Carregado automaticamente via import.meta.glob em App.tsx quando
 * VITE_CLIENT_CODE=apex.
 */

import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

// ─── Lazy imports ────────────────────────────────────────────────────────────

// Ocorrências - Extravios
const ExtravioListPage = lazy(() =>
  import('./pages/ocorrencias/extravio/ExtravioListPage').then(m => ({ default: m.ExtravioListPage }))
);

// Ocorrências - Faltas
const FaltaListPage = lazy(() =>
  import('./pages/ocorrencias/falta/FaltaListPage').then(m => ({ default: m.FaltaListPage }))
);
const FaltaFormPage = lazy(() =>
  import('./pages/ocorrencias/falta/FaltaFormPage').then(m => ({ default: m.FaltaFormPage }))
);

// ─── Rotas ───────────────────────────────────────────────────────────────────

export const clientRoutes = (
  <>
    {/* Ocorrências - Extravios */}
    <Route path="/apex/ocorrencias/extravios" element={<ExtravioListPage />} />

    {/* Ocorrências - Faltas */}
    <Route path="/apex/ocorrencias/faltas"         element={<FaltaListPage />} />
    <Route path="/apex/ocorrencias/faltas/nova"    element={<FaltaFormPage />} />
    <Route path="/apex/ocorrencias/faltas/:id"     element={<FaltaFormPage />} />
  </>
);
